import { timeout } from 'd3';
import { setCookie } from '../utils/fn';

window.widgets = window.widgets || {};

export const newsletter = (window.widgets.newsletter = () => {
  const newsletterWidgets = document.querySelectorAll('.widget-newsletter');
  const currentEdition = document.body.dataset.edtn;
  const msntClientId = gtmDataLayer[0].msntClientId;

  const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  function toggleState(widget, state, message = '') {
    const stateContainer = widget.querySelector('.widget-newsletter__state');
    const form = widget.querySelector('.widget-newsletter__form');

    if (!form || !stateContainer) return;

    const messageContainer = stateContainer.querySelector(
      '.widget-newsletter__message',
    );
    const refreshButton = stateContainer.querySelector(
      '.widget-newsletter__refresh-button',
    );

    const isFormVisible = state === 'form';
    form.classList.toggle('hidden', !isFormVisible);
    stateContainer.classList.toggle('hidden', isFormVisible);

    if (!isFormVisible) {
      if (messageContainer) {
        messageContainer.innerHTML = message;
        messageContainer.classList.toggle('error', state === 'error');
        messageContainer.classList.toggle('success', state === 'success');
      }
      stateContainer.classList.toggle('success', state === 'success');
      if (refreshButton) {
        refreshButton.classList.toggle('hidden', state !== 'error');
      }
    }
  }

  async function handleSubmit(event, widget) {
    event.preventDefault();
    const emailInput = widget.querySelector('input[type="email"]');

    if (!emailInput) return;

    if (!emailRegExp.test(emailInput.value)) {
      emailInput.setCustomValidity('Please enter a valid email address');
      emailInput.reportValidity();
      return;
    }

    const requestBody = new URLSearchParams({
      email: emailInput.value,
      allow_notification: true,
      client_id: msntClientId,
      country_id: 230,
      edition: currentEdition,
    });

    try {
      const response = await fetch(
        'https://accounts.motorsportnetwork.com/api/subscription',
        {
          method: 'POST',
          body: requestBody,
        },
      );
      const data = await response.json();

      if (!data.status) {
        toggleState(
          widget,
          'error',
          'Oops, something went wrong. Please try again later.',
        );
      } else {
        gtmDataLayer.push({
          event: 'GAEvent',
          ga_eventCategory: 'conversion',
          ga_eventAction: 'newsletterAdhesionUnit',
          ga_eventLabel: 'newsletterFormSubmitedConversion',
          ga_eventValue: '',
          ga_eventNoninteractive: true,
        });
        toggleState(widget, 'success', 'Thank you for signing up!');
        setCookie('newsletter_subscription', 1, 3650);
      }
    } catch (error) {
      console.error('Newsletter signup error:', error);
      toggleState(
        widget,
        'error',
        'Oops, something went wrong. Please try again later.',
      );
    } finally {
      const form = widget.querySelector('form');
      if (form) form.reset();
    }
  }

  newsletterWidgets.forEach((widget) => {
    const form = widget.querySelector('form');
    const refreshButton = widget.querySelector(
      '.widget-newsletter__refresh-button',
    );

    if (form) {
      form.addEventListener('submit', (e) => handleSubmit(e, widget));
      if (refreshButton) {
        refreshButton.addEventListener('click', () =>
          toggleState(widget, 'form'),
        )
      }
      const emailInput = form.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.addEventListener('input', (e) => {
          e.target.setCustomValidity('');
        });
      }
    }

    if (refreshButton) {
      refreshButton.addEventListener('click', () =>
        toggleState(widget, 'form'),
      );
    }
  });
});